import get from 'lodash/get';
import moment from 'moment';

const UPDATE_DATES_FORMAT = 'YYYY-MM-DD HH:mm:ss';

export const makeChildUpdateBookingDates = (start, end) => {
  const momentStart = moment(start);
  const momentEnd = moment(end);
  return {
    bookingStart: momentStart.format(UPDATE_DATES_FORMAT),
    bookingStartTimestamp: momentStart.valueOf(),
    bookingEnd: momentEnd.format(UPDATE_DATES_FORMAT),
    bookingEndTimestamp: momentEnd.valueOf(),
  };
};

export const getUpdateObjs = tx => {
  // Get both data sources with fallbacks
  const bookingUpdates = get(tx, 'attributes.protectedData.bookingUpdates', null);
  const childTransactions = get(tx, 'attributes.protectedData.childTransaction', []);

  // Normalize both to arrays
  const normalizedBookingUpdates = !bookingUpdates ? [] : 
                                Array.isArray(bookingUpdates) ? bookingUpdates : [bookingUpdates];
  const normalizedChildTransactions = Array.isArray(childTransactions) ? childTransactions : 
                                    childTransactions ? [childTransactions] : [];

  // Function to normalize a single transaction object to the desired format
  const normalizeTx = (txObj) => {
    // Handle both formats for transaction ID
    const txId = txObj.transactionId || txObj.txId || txObj.childTransaction;
    
    // Handle both formats for booking start
    const bookingStart = txObj.bookingStart || txObj.startUTC || 
                        (txObj.previousStart && moment(txObj.previousStart, UPDATE_DATES_FORMAT).format('YYYY-MM-DD HH:mm:ss'));
    
    // Handle both formats for booking end
    const bookingEnd = txObj.bookingEnd || txObj.endUTC || 
                      (txObj.previousEnd && moment(txObj.previousEnd, UPDATE_DATES_FORMAT).format('YYYY-MM-DD HH:mm:ss'));
    
    // Handle both formats for timestamps
    const bookingStartTimestamp = txObj.bookingStartTimestamp || txObj.start || txObj.updatedStart || 
                                 (txObj.bookingStart ? moment(txObj.bookingStart, UPDATE_DATES_FORMAT).valueOf() : 
                                 (txObj.startUTC ? moment(txObj.startUTC, UPDATE_DATES_FORMAT).valueOf() : null));
    
    const bookingEndTimestamp = txObj.bookingEndTimestamp || txObj.end || txObj.updatedEnd || 
                               (txObj.bookingEnd ? moment(txObj.bookingEnd, UPDATE_DATES_FORMAT).valueOf() : 
                               (txObj.endUTC ? moment(txObj.endUTC, UPDATE_DATES_FORMAT).valueOf() : null));

    return {
      txId,
      bookingStart,
      bookingEnd,
      bookingStartTimestamp,
      bookingEndTimestamp,
      // Include additional fields if they exist
      ...(txObj.priceCharged && { priceCharged: txObj.priceCharged })
    };
  };

  // Process child transactions first, then booking updates
  const allUpdates = [
    ...normalizedChildTransactions.map(normalizeTx),
    ...normalizedBookingUpdates.map(normalizeTx)
  ];

  return allUpdates;
};

export const getLastUpdateObj = tx => {
  const updateObjs = getUpdateObjs(tx);
  return updateObjs.length ? updateObjs[updateObjs.length - 1] : {
    bookingStart: null,
    bookingEnd: null,
  };
};

export const lastUpdateTransactionPayinTotal = tx => {
  return tx ? tx.attributes.payinTotal : null;
};

export const lastUpdateTransactionLineItems = tx => {
  return tx ? tx.attributes.lineItems : [];
};
